<div class="verification-password-page min-h-50 text-white">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Changer le mot de passe</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-1 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading">
                            MOT DE PASSE <span style="color : #BADFFF"> OUBLIÉ ?
                            </span>
                        </h1>
                        <h6 class="description">
                            Veuillez renseigner votre nouveau mot de passe
                        </h6>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="verification-password-bloc py-5">
        <div class="bloc-verification-password container">
            <div class="bg-white shadow rounded">
                <div class="row">
                    <div class="col-md-7 ">
                        <div *ngIf="isLoader" class="form-left h-100 py-5 px-5">
                            <div *ngIf="showError && errorMessage" class="col-12">
                                <div class="alert alert-danger" *ngIf="showError" [innerHTML]="errorMessage">
                                </div>
                            </div>
                            <form *ngIf="_isCheckedToken " action="#" #formRef="ngForm" novalidate>
                                <div class="list list-infos">
                                    <div class="infos-item">
                                        <div class="form-bloc">
                                            <div class="input-group">
                                                <div class="input-group-text"><i class="bi bi-lock-fill"></i></div>
                                                <input class="form-control" type="password" name="password"
                                                    aria-label="Mot de passe"
                                                    placeholder="MOT DE PASSE*" id="pwd-infos" [(ngModel)]="newPassword"
                                                    pattern="(.*){8}" reverse="true" validatePassword="password"
                                                    validateEqualTo="confirmPassword"
                                                    (keyup)="pressConfirmPwd(confirmPwd, newPassword)"
                                                    #password="ngModel" required>
                                            </div>
                                            <div class="input-group my-2">
                                                <div class="input-group-text"><i class="bi bi-lock-fill"></i></div>
                                                <input class="form-control" type="password" name="confirmPassword"
                                                    aria-label="Confirmer le mot de passe"
                                                    placeholder="CONFIRMER LE MOT DE PASSE*" id="pwdc-infos"
                                                    [(ngModel)]="confirmPwd" validateEqualTo="password"
                                                    validatePassword="confirmPassword" #confirmPassword="ngModel"
                                                    reverse="true" (keyup)="pressConfirmPwd(newPassword, confirmPwd)"
                                                    required>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="required-texte">* Champs obligatoires</p>
                                    <div class="btn-action float-end">

                                        <button class="btn btn-primary px-4 float-end " type="submit"
                                            (click)="changePassword(newPassword)" [disabled]="!isPressedConfirm ">
                                            <div *ngIf="isLoaderChange" class="spinner-border text-light" role="status">
                                            </div>
                                            <span *ngIf="!isLoaderChange"> Envoyer</span>


                                        </button>
                                    </div>
                                </div>
                            </form>

                        </div>
                        <div *ngIf="!isLoader" class="text-center form-left h-100 py-5 px-5">
                            <span class="spinner-border text-danger" role="status"></span>
                        </div>
                    </div>
                    <div class="col-md-5 ">
                        <div class="form-right h-100 bg-primary text-white text-start p-5">
                            Le nouveau mot de passe pour votre compte <span class="blue-text"><strong>THE DOOR
                                    MAN</strong></span>, doit avoir :
                            <div class="clearfix float-content mt-2">
                                <ul>
                                    <li>Au moins 8 caractères Majuscules et miniscules</li>
                                    <li>Au moins 1 chiffre</li>
                                </ul>

                                <button [routerLink]="['/amis-tdm/liste']" type="submit"
                                    class="btn btn-outlined  px-4 float-end mt-4">
                                    Trouver mon Conseiller</button>
                                <button [routerLink]="['/connexion']" routerLinkActive="router-link-active"
                                    type="submit" class="btn btn-secondary  px-4 float-end mt-4 mx-2">
                                    Se connecter</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
